import { optimize } from 'svgo/dist/svgo.browser.js';

const optimizeSvg = (svg: string): string => {
    const { data: optimizedSvg } = optimize(svg, {
        plugins: [
            {
                name: 'preset-default',
                params: {
                    overrides: {
                        removeViewBox: false,
                        minifyStyles: false,
                    },
                },
            },
        ],
    });

    return optimizedSvg;
};

const getSVGCode = (url: string): Promise<SVGElement> =>
    new Promise((resolve, reject) => {
        const svgContainer = document.createElement('div');
        svgContainer.id = 'editor';
        svgContainer.style.display = 'none';
        document.body.appendChild(svgContainer);

        fetch(url)
            .then(response => response.text())
            .then(svg => {
                svgContainer.innerHTML = optimizeSvg(svg);

                const code = document.querySelector('#editor svg') as SVGElement;
                if (!code) {
                    reject();
                }
                svgContainer?.parentNode?.removeChild(svgContainer);
                resolve(code);
            });
    });

const setSvgDefaultWidth = (svg: string): string => svg.replace('width="128"', 'width="512"');

const setSvgDefaultHeight = (svg: string): string => svg.replace('height="128"', 'height="512"');

const resizeSvgToDefault = (svgCode: string): string => {
    let defaultSvg: string;
    defaultSvg = setSvgDefaultHeight(svgCode);
    defaultSvg = setSvgDefaultWidth(defaultSvg);

    return defaultSvg;
};

const normalize = (val: number, max: number, min: number) => {
    return (val - min) / (max - min);
};

const hexToAlpha = (alphaHexString: string) => {
    return normalize(parseInt(alphaHexString, 16), 255, 0);
};

export const EditorHelpers = {
    getSVGCode,
    resizeSvgToDefault,
    hexToAlpha,
};
